import { render } from "./PasswordForm.vue?vue&type=template&id=0ffa9870&scoped=true"
import script from "./PasswordForm.vue?vue&type=script&lang=js"
export * from "./PasswordForm.vue?vue&type=script&lang=js"

import "./PasswordForm.vue?vue&type=style&index=0&id=0ffa9870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffa9870"]])

export default __exports__